import React from 'react';
import PropTypes from 'prop-types';
import { incrementBuildInfoClick } from '~spa/Utils/BuildInfo';
import {
    useIsUserLoggedIn,
} from '~SpectateStore/hooks/userHooks';
import { useIsNativeApp } from '~SpectateStore/hooks/clientStateHooks';

import './titlebar.scss';

const TitleBar = ({children}) => {
    const isUserLoggedIn = useIsUserLoggedIn();
    const isNativeApp = useIsNativeApp();
    if (isUserLoggedIn || isNativeApp) {
        return null;
    }

    return (
        <div className="h1-bar" onClick={incrementBuildInfoClick}>
            <h1 className="h1-bar__title" dir='auto'>
                { children }
            </h1>
        </div>
    );
};

TitleBar.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

TitleBar.defaultProps = {
    children: '',
};

export default TitleBar;
